import script from "./AdditionalServiceItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalServiceItem.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalServiceItem.vue?vue&type=style&index=0&id=3382e2b1&lang=scss"

const __exports__ = script;

export default __exports__